import { FoodName, StyledNameAndPortion } from "./styled"
import { FlexBox } from "components/Common/FlexBox"
import PortionOnlyFormItem from "components/portion/PortionOnlyFormItem"
import { IAIScanIngredientOption } from "model/food/types/AIScan.types"

interface IAIIngredientNameAndPortionProps {
  ingredient: IAIScanIngredientOption
  portionValue: number
  onPortionChange: (portion: number) => void
  unit: string
  setIsPortionValid?: (isValid: boolean) => void
  calories?: number
}

const AIIngredientNameAndPortion = (
  props: IAIIngredientNameAndPortionProps,
) => {
  const {
    ingredient,
    onPortionChange,
    portionValue,
    unit,
    setIsPortionValid,
    calories,
  } = props

  return (
    <StyledNameAndPortion>
      <FlexBox $alignItems="center" $gap={8} style={{ padding: "4px 0" }}>
        <FoodName>{ingredient.name}</FoodName>
      </FlexBox>

      <PortionOnlyFormItem
        unit={unit}
        portionValue={portionValue}
        onPortionChange={onPortionChange}
        setIsPortionValid={setIsPortionValid}
        calories={calories}
        gram={null}
      />
    </StyledNameAndPortion>
  )
}

export default AIIngredientNameAndPortion
